import { createStore, combineReducers } from 'redux';

// Minimal Redux store for bxi-landing (guest view)
// This provides a basic Redux setup so components that use Redux don't break

// Stub reducers - these don't do anything but prevent errors
const productReducer = (state = {}, action) => {
  return state;
};

const rootReducer = combineReducers({
  product: productReducer,
});

const store = createStore(rootReducer);

export default store;
